export const data = [
  {
    text: 'Thank you very much for this - this gives me a clearer picture of what to do. A lot of times I just get overwhelmed in the vet office and can\'t think of what to ask! This has been really helpful.',
    name: 'Mark',
  },
  {
    text: 'Spot on! My vet is closed all weekend so I got nervous, I wanted to make sure she wasn\'t dehydrated. Thank you!',
    name: 'Beth',
  },
  {
    text: 'Thank you for the peace of mind! Much appreciated.',
    name: 'Sammy',
  },
  {
    text: 'Thank you Dr. Sara :) I couldn\'t find an answer online!',
    name: 'Josh',
  },
  {
    text: 'Thank you so much. I think I can sleep now knowing he will be ok. I appreciate the help.',
    name: 'Adrianne',
  },
  {
    text: 'I was able to cover so many concerns with the vet today, without paying the expensive emergency care fee! Thank you for being available like this. Its really comforting and amazing and appreciated.',
    name: 'Alex',
  },
  {
    text: 'Teddy is my life and I always go over the top to help him if I get the feeling something could be wrong. I feel very good after talking with the vet on Wag!!',
    name: 'Christel',
  },
  {
    text: 'I\'ve been trying to find stuff online since I saw the leaf hanging out of his mouth and I read everything from "don\'t worry" to "immediate death". I really appreciate the vets helping me!',
    name: 'Amy',
  },
];
